import { useState, useCallback, useMemo } from 'react';
export const usePopover = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handlePopoverClick = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);
    const handlePopoverClose = useCallback(() => {
        setAnchorEl(null);
    }, []);
    const activeId = useMemo(() => { var _a; return (_a = anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.dataset.id) !== null && _a !== void 0 ? _a : ''; }, [anchorEl]);
    const open = useMemo(() => !!anchorEl, [anchorEl]);
    return { open, anchorEl, activeId, handlePopoverClick, handlePopoverClose };
};
//# sourceMappingURL=usePopover.js.map